import { useEffect } from "react";
import './ListCompany.css';
import companyService from '/src/features/administration/company/services/companyService';
import BlockCompany from "../BlockCompany/BlockCompany";
import DropdownCompany from "../DropdownCompany/DropdownCompany";
function ListCompany({state}) {

    const { getCompaniesWithoutPagination } = companyService;
    const [companies, setCompanies] = state

    const regex = /[\-_ \d]|(?<=[a-z])(?=[A-Z])/;
    const getPrefix = (name) => {
        const normalizedName = name.toLowerCase();
        const match = normalizedName.split(regex)[0];
        return match;
    };
    
    const groupCompaniesByPrefix = (companies) => {
        const grouped = {};
        const uniqueCompanies = [];
    
        companies.forEach((company) => {
            const prefix = getPrefix(company.name);
            if (!grouped[prefix]) {
                grouped[prefix] = [];
            }
            grouped[prefix].push(company);
        });
    
    
        Object.keys(grouped).forEach((prefix) => {
            if (grouped[prefix].length === 1) {
                uniqueCompanies.push(grouped[prefix][0]);
                delete grouped[prefix];
            }
        });
    
        return { grouped, unique: uniqueCompanies };
    };
   
    useEffect( () => {
        let isCompaniesInfo = true;

        const fetchData = async () => {
            const [response, error] = await getCompaniesWithoutPagination();
            if(error != null) {
                
            }
            setCompanies(response)
        }

        fetchData().catch((err) => console.error(err));   

        return () => isCompaniesInfo = false;
    }, [setCompanies]);

    const { grouped, unique } = groupCompaniesByPrefix(companies);

    const combinedList = [
        ...unique.map((company) => ({ type: 'company', company, sortKey: company.name })),
        ...Object.keys(grouped).map((prefix) => ({ type: 'group', prefix, companies: grouped[prefix], sortKey: prefix }))
    ];

    // Trier la liste combinée par sortKey
    combinedList.sort((a, b) => a.sortKey.localeCompare(b.sortKey));

    return (
        <div className="list scrollbar">
            {combinedList.map((item, index) =>
                item.type === 'group' ? (
                    <DropdownCompany key={`group-${item.prefix}`} prefix={item.prefix} companies={item.companies} />
                ) : (
                    <BlockCompany key={`company-${item.company.id}`} {...item.company}  />
                )
            )}
        </div>
    )
}

export default ListCompany




